import React from "react";

const ChildThemeLoader = () => {
    let childTheme = process.env.REACT_APP_CHILD_THEME;
    if(typeof(childTheme) === "undefined"){
        childTheme = "default";
    }
    switch(childTheme){
        case 'clean':
            require("../themes/clean.scss");
            break;
        default:
            require("../themes/theme.scss");
            break;
    }

    return null;
};

export default ChildThemeLoader;